<template>
	<Layout
		v-if="is_view"
		:user="user"
		:member_info="user"
		:codes="codes"
		:shop_info="shop_info"
		:category_list="category_list"
	/>
	<Loading
		v-else
	></Loading>
</template>

<script>
	import Layout from '@/view/Layout/Layout.vue'
	import {codes} from "@/resources/config/codes";
	import {Base64} from "js-base64";
	import Loading from "@/view/Layout/Loading";

export default {

	name: 'App'
	,components: {Loading, Layout }
	,data: () => ({
		codes: codes
		, user: {

		}
		, shop_info: {

		}
		, items_category: []
		, is_view: true
	})
	, computed: {
		category_list: function(){
			return this.items_category
		}
	}
	,methods: {
		isAuth: async function(){

			let TOKEN = sessionStorage.getItem(Base64.encode(process.env.VUE_APP_NAME + 'AT'))
			let skip = false
			let except = ['auth', 'error']
			let path = document.location.href

			except.forEach(function (val) {
				if (path.toLowerCase().indexOf(val) > -1) {
					skip = true
					return false
				}
			})
			if(this.$route.fullPath == '/'){
				skip = true
			}
console.log('skip', skip, this.$route)
			if (TOKEN) {
				await this.getBaseInfo()
			}else{

				if(!skip) {
					document.location.href = process.env.VUE_APP_PUBLIC_PATH
				}
			}
		}

		,getBaseInfo: async function(){
			try{
				const result = await this.$request.init({
					method: 'get'
					,url: 'main/getBaseInfo'
				})

				if(result.success){
					this.setCode(result.data.code_list)
					let d = result.data.account_info

					if(d){
						d = JSON.parse(Base64.decode(d))
						this.$set(this, 'user', d ? d : {})
					}
console.log('user', this.user)
					if(result.data.last_grade){
						this.$set(this.user, 'last_grade', result.data.last_grade)
					}
				}else{
					throw result.message
				}
			}catch (e) {
				console.log(e)
				setTimeout(() => {
					this.$bus.$emit('logout')
				}, 100)
			}
		}
		,setCode: function(code_list){
			let list = {}
			code_list.forEach(function(code){
				let main = list[code.main_code]
				if(!main){
					code.items = []
					list[code.main_code] = code
				}
				list[code.main_code].items.push(code)
			})

			Object.assign(list, this.codes)
			this.$set(this, 'codes', list)
		}
		, to: async function ({name, path, params, query = {}, not_query, hash, type}) {
			// console.log('to params', name, this.$route.name)

			query.a = Math.random()

			let router = this.$router.resolve({ name: name, path: path, params: params, query: query, hash: hash ? '#' + hash : ''})
			// console.log('params', params)
			// console.log('router', router)
			if (!not_query) {
				localStorage.removeItem('query')
				this.query = {}
			} else {
				this.query = query
			}

			if(type == 'href'){
				document.location.href = router.href
			}else{
				await this.$router.push({ path: router.route.fullPath })
			}
		}
		, logout: async function(){
			try {
				await this.$request.init({
					method: 'post'
					, url: 'member/logout'
				})

			}finally {
				sessionStorage.clear()
				localStorage.removeItem('login_info')
				localStorage.removeItem(process.env.VUE_APP_NAME + 'A')
				setTimeout(() => {
					this.$bus.$emit('to', {name: 'intro', type: 'href'})
				}, 500)
			}
		}
	}
	, created() {

		localStorage.removeItem(process.env.VUE_APP_NAME + 'A')
		localStorage.removeItem(process.env.VUE_APP_NAME + 'N')
		localStorage.removeItem(process.env.VUE_APP_NAME + 'P')

		this.$bus.$on('to', ({ name, path, params, query, not_query, hash, type}) => {
			this.to({ name, path, params, query, not_query, hash, type})
		})
		this.$bus.$on('goBack', () => {
			this.$router.back()
		})
		this.$bus.$on('logout', () => {
			this.logout()
		})

		this.$bus.$on('onErrorImage', (e) => {
			e.target.src = require('@/assets/images/common/empty-image.png')
		})

		this.$bus.$on('setUser', (e) => {
			e.forEach( (item) => {
				this.user[item.key] = item.val
			})
		})
		this.isAuth()
	}
	, watch: {
		$route(){
			document.body.scrollTo({top: 0, behavior: 'smooth'})
		}
	}
};
</script>

<style>


.slide-fade-enter-active {
	transition: all .3s ease;
}
.slide-fade-leave-active {
	transition: all .0s ease;
}
.slide-fade-enter{
	transform: translateY(100%);

	overflow: hidden;
	height: 100%;
}
.slide-fade-leave, .slide-fade-leave-to {
	transform: translateY(100%) ;
	opacity: 0;
	overflow: hidden;
}

@media (max-width: 720px) {

	.icon-15 {
		width: 15px; height: 15px;
		border-radius: 100%;
	}
}

@media (min-width: 720px) {

	.icon-32 {
		width: 32px; height: 32px;
		border-radius: 100%;
	}
}
</style>